// src/components/GlobalModal.jsx

import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../redux/features/modalSlice";
import "../GlobalModel.css";
import DeleteModal from "../common/DeleteModal";
import StatusModal from "../common/ChangeStatusModal";
import CreateCategory from "../Pages/CategoryManagment/createCategory";
import EditCity from "../Pages/City/EditCity";
import ViewCity from "../Pages/City/ViewCity";
import ViewState from "../Pages/State/viewState";
import EditState from "../Pages/State/updateState";
import ViewSubCategory from "../Pages/SubCategoryManagment/viewSubCategories";
import EditSubCategory from "../Pages/SubCategoryManagment/updateSubCategory";
import ViewAmenities from "../Pages/Amenities/ViewAmenities";
import EditAmenities from "../Pages/Amenities/EditAmenities";
import ViewBlog from "../Pages/Blog/ViewBlog";
import EditBlog from "../Pages/Blog/UpdateBlog";
// import ViewTestimonial from "../Pages/FamilyManagment/ViewTestimonials";
// import EditTestimonial from "../Pages/FamilyManagment/UpdateTestimonials";
import EditCategory from "../Pages/CategoryManagment/updateCategory";
import ViewCategory from "../Pages/CategoryManagment/viewCategories";
import ViewLocation from "../Pages/Location/viewLocation";
import UpdateLocation from "../Pages/Location/updateLocation";

// ================= GOTRA IMPORTS =================
import ViewGotra from "../Pages/Gotra/ViewGotra";
import EditGotra from "../Pages/Gotra/EditGotra";

// ================= NANIHAL GOTRA IMPORTS =================
import NanihalViewGotra from "../Pages/NanihalGotra/ViewGotra";
import NanihalEditGotra from "../Pages/NanihalGotra/EditGotra";

// ================= KULDEVI IMPORTS =================
import KuldeviView from "../Pages/Kuldevi/ViewGotra";
import KuldeviEdit from "../Pages/Kuldevi/EditGotra";

// ================= EDUCATION IMPORTS =================
import EducationView from "../Pages/Educations/ViewEducation";
import EducationEdit from "../Pages/Educations/EditEducation";

// ================= BANNER IMPORTS =================
import BannerView from "../Pages/BannerManagment/viewBanner";
import UpdateBanner from "../Pages/BannerManagment/updateBanner";
import CreateBanner from "../Pages/BannerManagment/createBanner";

// ================= OCCUPATION IMPORTS =================
import OccupationView from "../Pages/Occupation/ViewOccupation";
import OccupationEdit from "../Pages/Occupation/EditOccupation";

// ================= ADMIN IMPORTS =================
import ViewAdmin from "../Pages/SubAdminManagment/AdminView";
import EditAdmin from "../Pages/SubAdminManagment/AdminUpdate";

// ================= EVENT IMPORTS =================
import ViewEvent from "../Pages/EventManagement/ViewEvents";
import EditEvent from "../Pages/EventManagement/EditEvents";


import ViewNews from "../Pages/NewsManagement/ViewNews";
import EditNews from "../Pages/NewsManagement/EditNews";
import ViewEmployment from "../Pages/Employment/ViewEmployment";
import ViewApplications from "../Pages/Employment/ViewApplications";

import ViewScholarship from "../Pages/Scholarships/ViewScholarship";
import ViewStudent from "../Pages/Scholarships/ViewStudent";
import ViewScholarshipApplications from "../Pages/Scholarships/ViewScholarshipApplications";

import ViewBuilding from "../Pages/Building/ViewBuilding";
import ViewBooking from "../Pages/Building/ViewBooking";
import BuildingImages from "../Pages/Building/BuildingImages";


// Waad Modals
import EditWaad from '../Pages/waad/EditWaad';
import ViewWaad from '../Pages/waad/ViewWaad';

// Gaon Modals
import EditGaon from '../Pages/gaon/EditGaon';
import ViewGaon from '../Pages/gaon/ViewGaon';
import ViewSelection from "../Pages/Selections/ViewSelection";



const GlobalModal = () => {
  const dispatch = useDispatch();
  const modalState = useSelector((state) => state.modal);

  const { isOpen, type, data, title } = modalState;

  // ================= DELETE TYPES =================
  const deleteTypes = [
    "delete-admin",
    "delete-category",
    "delete-city",
    "delete-state",
    "delete-subcategory",
    "delete-amenities",
    "location-delete",
    "delete-blog",
    "delete-testimonial",
    "delete-product",
    "delete-gotra",
    "delete-nanihal-gotra",
    "delete-kuldevi",
    "delete-education",
    "delete-occupation",
    "delete-banner",
    "delete-event", // ADDED
  ];

  // ================= STATUS TYPES =================
  const statusTypes = [
    "status-admin",
    "status-category",
    "status-city",
    "status-state",
    "status-subcategory",
    "status-amenities",
    "status-blog",
    "location-status",
    "status-testimonial",
    "status-product",
    "status-gotra",
    "status-nanihal-gotra",
    "status-kuldevi",
    "status-education",
    "status-occupation",
    "status-banner",
    "status-event", // ADDED
  ];

  if (!isOpen) return null;

  const renderContent = () => {
    // ================= DELETE MODAL =================
    if (deleteTypes.includes(type)) {
      return (
        <DeleteModal
          title={title}
          message={data?.message}
          apiUrl={data?.apiUrl}
          id={data?.id}
          onSuccess={data?.onSuccess}
        />
      );
    }

    // ================= STATUS MODAL =================
    if (statusTypes.includes(type)) {
      return (
        <StatusModal
          title={title}
          message={data?.message}
          apiUrl={data?.apiUrl}
          id={data?.id}
          currentStatus={data?.status}
          onSuccess={data?.onSuccess}
        />
      );
    }

    // ================= SWITCH CASES =================
    switch (type) {
      // ================= ADMIN =================
      case "view-admin":
        return <ViewAdmin data={data} />;
      case "edit-admin":
        return <EditAdmin data={data} />;

      // ================= CATEGORY =================
      case "create-category":
        return <CreateCategory />;
      case "view-category":
        return <ViewCategory data={data} />;
      case "edit-category":
        return <EditCategory data={data} />;
      case "view-building":
        return <ViewBuilding data={data} />;
      case "view-booking":
        return <ViewBooking data={data} />;
      case "building-images":
        return <BuildingImages data={data} />;
      case "view-scholarship":
        return <ViewScholarship data={data} />;
      case "view-student":
        return <ViewStudent data={data} />;
      case "view-scholarship-applications":
        return <ViewScholarshipApplications data={data} />;
      // ================= CITY =================
      case "view-city":
        return <ViewCity data={data} />;
      case "edit-city":
        return <EditCity data={data} />;

      // ================= STATE =================
      case "view-state":
        return <ViewState data={data} />;
      case "edit-state":
        return <EditState data={data} />;
      // Add this case
      case "view-selection":
        return <ViewSelection data={data} />;

      // ================= SUB CATEGORY =================
      case "view-subcategory":
        return <ViewSubCategory data={data} />;
      case "edit-subcategory":
        return <EditSubCategory data={data} />;
      case "view-employment":
        return <ViewEmployment data={data} />;
      case "view-applications":
        return <ViewApplications data={data} />;
      // ================= AMENITIES =================
      case "view-amenities":
        return <ViewAmenities data={data} />;
      case "edit-amenities":
        return <EditAmenities data={data} />;

      // ================= BLOG =================
      case "view-blog":
        return <ViewBlog data={data} />;
      case "edit-blog":
        return <EditBlog data={data} />;

      // ================= LOCATION =================
      case "view-location":
        return <ViewLocation data={data} />;
      case "edit-location":
        return <UpdateLocation data={data} />;

      // ================= TESTIMONIAL =================
      // case "view-testimonial":
      //   return <ViewTestimonial data={data} />;
      // case "edit-testimonial":
      //   return <EditTestimonial data={data} />;

      // ================= REGULAR GOTRA =================
      case "view-gotra":
        return <ViewGotra data={data} />;
      case "edit-gotra":
        return <EditGotra data={data} />;

      // ================= NANIHAL GOTRA =================
      case "view-nanihal-gotra":
        return <NanihalViewGotra data={data} />;
      case "edit-nanihal-gotra":
        return <NanihalEditGotra data={data} />;

      // ================= KULDEVI =================
      case "view-kuldevi":
        return <KuldeviView data={data} />;
      case "edit-kuldevi":
        return <KuldeviEdit data={data} />;

      // ================= EDUCATION =================
      case "view-education":
        return <EducationView data={data} />;
      case "edit-education":
        return <EducationEdit data={data} />;

      // ================= EVENT =================
      case "view-event":
        return <ViewEvent data={data} />;
      case "edit-event": // FIXED: Changed from "edit-education" to "edit-event"
        return <EditEvent data={data} />;

      case "view-news":
        return <ViewNews data={data} />;
      case "edit-news":
        return <EditNews data={data} />;
      // ================= BANNER =================
      case "create-banner":
        return <CreateBanner refreshData={data} />;
      case "view-banner":
        return <BannerView data={data} />;
      case "edit-banner":
        return <UpdateBanner data={data} />;

      // ================= OCCUPATION =================
      case "view-occupation":
        return <OccupationView data={data} />;
      case "edit-occupation":
        return <OccupationEdit data={data} />;
      // Waad Modals
      case "edit-waad":
        return <EditWaad data={data} />;
      case "view-waad":
        return <ViewWaad data={data} />;
      // case "delete-waad":
      //   return <DeleteModal data={data} />;

      // Gaon Modals
      case "edit-gaon":
        return <EditGaon data={data} />;
      case "view-gaon":
        return <ViewGaon data={data} />;
      // case "delete-gaon":
      //   return <DeleteModal data={data} />;

      default:
        return null;
    }
  };

  return (
    <div className="modal-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) {
        dispatch(closeModal());
      }
    }}>
      <div className="modal-box">
        {/* HEADER */}
        <div className="modal-header">
          <h2 className="heading">{title}</h2>
          <button className="close-btn" onClick={() => dispatch(closeModal())}>
            ✕
          </button>
        </div>

        {/* CONTENT */}
        <div className="modal-content">{renderContent()}</div>
      </div>
    </div>
  );
};

export default GlobalModal;